export * from './models.js';
export const apiBaseUrl = import.meta.env.VITE_SEARCH_API_URI ?? '';
